import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import MindsetsJsSDK, {filterConstants} from "mindsets-js-sdk";
import Graph from "./Graph";
import GraphVector from "./GraphVector";
import GraphRegression from "./GraphRegression";

export default function () {
    const params = useParams();
    const [user, setUser] = useState(null);
    const [dataSMP, setDataSMP] = useState(null);
    const [dataELA, setDataELA] = useState(null);
    const [dataFR, setDataFR] = useState(null);

    useEffect(() => {
        MindsetsJsSDK().API
            .get('users/' + params.student_id, {'filters[persona][0]': filterConstants.EXPRESSION_EQUAL + '=student'})
            .then(response => setUser(response.user))
            .then(() => {
                MindsetsJsSDK().API
                    .get('statistics/students/' + params.student_id + '/growth/ccmps')
                    .then(setDataSMP);
                MindsetsJsSDK().API
                    .get('statistics/students/' + params.student_id + '/growth/ela')
                    .then(setDataELA);
                MindsetsJsSDK().API
                    .get('statistics/students/' + params.student_id + '/growth/mindsets')
                    .then(setDataFR);
            })
    }, []);

    function renderTable(data) {
        return (
            <div className='d-flex flex-gap-10 flex-wrap'>
                {data.map(row => {
                    return (
                        <div key={row.name} className='bordered'>
                            <div className='d-flex flex-gap-5 no-wrap'>
                                <div>{row.name}</div>
                                <div>{row.angle}º</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    function renderSMP() {
        if (!dataSMP) {
            return null;
        }

        return (
            <div>
                <h3>CommonCore SMPs</h3>
                <div className='row'>
                    <div className='col-8'>
                        <Graph data={dataSMP.data} key='smp' id='smp'/>
                    </div>
                    <div className='col-4'>
                        <GraphVector data={dataSMP.regression} key='smp-vector' id='smp-vector'/>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-8'>
                        <GraphRegression data={dataSMP.regression} key='smp-regression' id='smp-regression'/>
                    </div>
                    <div className='col-4'>
                        {renderTable(dataSMP.regression)}
                    </div>
                </div>
            </div>
        );
    }

    function renderELA() {
        if (!dataELA) {
            return null;
        }

        return (
            <div className='mt-4'>
                <h3>CommonCore ELA</h3>
                <div className='row'>
                    <div className='col-8'>
                        <Graph data={dataELA.data} key='ela' id='ela'/>
                    </div>
                    <div className='col-4'>
                        <GraphVector data={dataELA.regression} key='ela-vector' id='ela-vector'/>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-8'>
                        <GraphRegression data={dataELA.regression} key='ela-regression' id='ela-regression'/>
                    </div>
                    <div className='col-4'>
                        {renderTable(dataELA.regression)}
                    </div>
                </div>
            </div>
        );
    }

    function renderFR() {
        if (!dataFR) {
            return null;
        }

        return (
            <div className='mt-4'>
                <h3>Future-ready Skills</h3>
                <div className='row'>
                    <div className='col-8'>
                        <Graph data={dataFR.data} key='fr' id='fr'/>
                    </div>
                    <div className='col-4'>
                        <GraphVector data={dataFR.regression} key='fr-vector' id='fr-vector'/>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-8'>
                        <GraphRegression data={dataFR.regression} key='fr-regression' id='fr-regression'/>
                    </div>
                    <div className='col-4'>
                        {renderTable(dataFR.regression)}
                    </div>
                </div>
            </div>
        );
    }

    if (!user) {
        return null;
    }

    return (
        <div>
            <title>Student Growth</title>
            <h1>{user.fname} {user.lname}'s Growth</h1>
            {renderSMP()}
            {renderELA()}
            {renderFR()}
        </div>
    );
}